/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createReducer, on } from '@ngrx/store';
import { GetFolderSuccess } from './configuration-location-actions';
import { ConfigurationLocationReturnCodes } from '../../models/configuration-location-return-codes';

export const ConfigurationLocationKey = 'ConfigurationLocation';

export interface ConfigurationLocationState {
  folderPath?: string;
  statusCode?: ConfigurationLocationReturnCodes;
}

export const initialConfigurationLocationState: ConfigurationLocationState = {
  folderPath: 'initial folder path',
  statusCode: ConfigurationLocationReturnCodes.Success,
};

export const ConfigurationLocationReducer = createReducer(
  initialConfigurationLocationState,

  on(GetFolderSuccess, (state, action) => {
    return ({
      ...state,
      folderPath: action.folderPath,
      statusCode: action.statusCode,
    });
  })
);
